import React from 'react';
import iconify from '../iconify';

const ChevronRightIcon = props => (
  <svg
    aria-hidden={true}
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 10L7.859 6.58a.695.695 0 0 1 0-.978.68.68 0 0 1 .969 0l3.83 3.908a.697.697 0 0 1 0 .979l-3.83 3.908c-.267.272-.701.27-.969 0s-.268-.707 0-.978L11 10z"
    />
  </svg>
);

export default iconify(ChevronRightIcon);
